/* Contoura PDP behaviors — adapted from the swipe's sl-pdp.js + native bundle engine (replaces MoonBundle) */
(function () {
  "use strict";
  if (window.__contouraPdp) return;
  window.__contouraPdp = true;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- reveal on scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll(".sl-reveal");
    if (!els.length) return;
    if (reduce || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("is-in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
      });
    }, { rootMargin: "0px 0px -10% 0px", threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- FAQ / accordions ---------- */
  function initFaq() {
    document.querySelectorAll(".sl-faq__q, .sl-acc__q").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var expanded = btn.getAttribute("aria-expanded") === "true";
        var panel = document.getElementById(btn.getAttribute("aria-controls"));
        btn.setAttribute("aria-expanded", String(!expanded));
        if (panel) panel.style.maxHeight = expanded ? "0px" : panel.scrollHeight + "px";
      });
    });
  }

  /* ---------- gallery ---------- */
  function initGallery() {
    document.querySelectorAll("[data-sl-gallery]").forEach(function (gal) {
      var slides = gal.querySelectorAll("[data-sl-slide]"),
          thumbs = gal.querySelectorAll("[data-sl-thumb]"),
          stage = gal.querySelector("[data-sl-stage]");
      if (!slides.length) return;
      function activate(idx) {
        if (idx < 0 || idx >= slides.length) return;
        var key = String(idx);
        slides.forEach(function (s) { s.classList.toggle("is-active", s.getAttribute("data-sl-slide") === key); });
        thumbs.forEach(function (t) {
          var on = t.getAttribute("data-index") === key;
          t.setAttribute("aria-current", on ? "true" : "false");
          if (on) t.scrollIntoView({ inline: "nearest", block: "nearest", behavior: reduce ? "auto" : "smooth" });
        });
      }
      function currentIndex() {
        for (var i = 0; i < slides.length; i++)
          if (slides[i].classList.contains("is-active")) return parseInt(slides[i].getAttribute("data-sl-slide"), 10) || 0;
        return 0;
      }
      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () { activate(parseInt(thumb.getAttribute("data-index"), 10)); });
      });
      if (stage && slides.length > 1) {
        var x0 = 0, y0 = 0, tracking = false, axis = null;
        stage.addEventListener("touchstart", function (e) {
          if (e.touches.length !== 1) { tracking = false; return; }
          x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; tracking = true; axis = null;
        }, { passive: true });
        stage.addEventListener("touchmove", function (e) {
          if (!tracking || e.touches.length !== 1) { tracking = false; return; }
          if (!axis) {
            var dx = e.touches[0].clientX - x0, dy = e.touches[0].clientY - y0;
            if (Math.abs(dx) > 8 || Math.abs(dy) > 8) axis = Math.abs(dx) > Math.abs(dy) ? "x" : "y";
          }
        }, { passive: true });
        stage.addEventListener("touchend", function (e) {
          if (!tracking) return;
          tracking = false;
          if (axis !== "x") return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) < 40) return;
          activate(currentIndex() + (dx < 0 ? 1 : -1));
        }, { passive: true });
        stage.addEventListener("touchcancel", function () { tracking = false; }, { passive: true });
      }
    });
  }

  function initThumbArrows() {
    document.querySelectorAll("[data-sl-gallery]").forEach(function (gal) {
      var strip = gal.querySelector("[data-sl-thumbstrip]"),
          prev = gal.querySelector("[data-sl-thumb-prev]"),
          next = gal.querySelector("[data-sl-thumb-next]");
      if (!strip || !prev || !next) return;
      function overflowing() { return strip.scrollWidth > strip.clientWidth + 1; }
      function update() {
        var show = overflowing();
        prev.hidden = !show || strip.scrollLeft <= 1;
        next.hidden = !show || strip.scrollLeft >= strip.scrollWidth - strip.clientWidth - 1;
      }
      function step() { return Math.max(strip.clientWidth * 0.8, 80); }
      prev.addEventListener("click", function () { strip.scrollBy({ left: -step(), behavior: "smooth" }); });
      next.addEventListener("click", function () { strip.scrollBy({ left: step(), behavior: "smooth" }); });
      strip.addEventListener("scroll", update, { passive: true });
      window.addEventListener("resize", update);
      window.addEventListener("load", update);
      update();
    });
  }

  /* ---------- sticky bar ---------- */
  function initSticky() {
    var sticky = document.querySelector("[data-sl-sticky]");
    if (!sticky) return;
    var anchor = document.querySelector("#shop-now");
    if (!anchor || !("IntersectionObserver" in window)) return;
    var so = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        sticky.classList.toggle("is-visible", !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    so.observe(anchor);
  }

  /* ---------- generic carousels ---------- */
  function initCarousels() {
    document.querySelectorAll("[data-sl-carousel]").forEach(function (car) {
      var track = car.querySelector("[data-sl-carousel-track]");
      if (!track) return;
      function step() {
        var f = track.firstElementChild, w = f ? f.getBoundingClientRect().width : 240;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 14;
        return w + gap;
      }
      var prev = car.querySelector("[data-sl-carousel-prev]"),
          next = car.querySelector("[data-sl-carousel-next]");
      if (prev) prev.addEventListener("click", function () { track.scrollBy({ left: -step() * 1.2, behavior: reduce ? "auto" : "smooth" }); });
      if (next) next.addEventListener("click", function () { track.scrollBy({ left: step() * 1.2, behavior: reduce ? "auto" : "smooth" }); });
      var dotsWrap = car.querySelector("[data-sl-carousel-dots]");
      if (dotsWrap) {
        var cards = track.children, dots = [];
        for (var i = 0; i < cards.length; i++) {
          var b = document.createElement("button");
          b.className = "sl-rev__dot"; b.type = "button";
          b.setAttribute("aria-label", "Go to item " + (i + 1));
          (function (idx) {
            b.addEventListener("click", function () {
              cards[idx].scrollIntoView({ behavior: reduce ? "auto" : "smooth", inline: "center", block: "nearest" });
            });
          })(i);
          dotsWrap.appendChild(b); dots.push(b);
        }
        var active = function () {
          var center = track.scrollLeft + track.clientWidth / 2, best = 0, bd = Infinity;
          for (var i2 = 0; i2 < cards.length; i2++) {
            var c = cards[i2], cc = c.offsetLeft + c.offsetWidth / 2, d = Math.abs(cc - center);
            if (d < bd) { bd = d; best = i2; }
          }
          dots.forEach(function (dot, i3) { dot.classList.toggle("is-active", i3 === best); });
        };
        track.addEventListener("scroll", function () { window.requestAnimationFrame(active); });
        active();
      }
    });
  }

  /* ---------- UGC videos ---------- */
  function initUgc() {
    var items = document.querySelectorAll("[data-sl-ugc]");
    if (!items.length) return;
    var vids = document.querySelectorAll("[data-sl-ugc] video");
    if ("IntersectionObserver" in window && !reduce) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {
              v.addEventListener("canplay", function () { var q = v.play(); if (q && q.catch) q.catch(function () {}); }, { once: true });
            });
          } else v.pause();
        });
      }, { threshold: 0.5 });
      vids.forEach(function (v) { io.observe(v); });
    } else {
      vids.forEach(function (v) { var p = v.play && v.play(); if (p && p.catch) p.catch(function () {}); });
    }
    items.forEach(function (item) {
      var v = item.querySelector("video");
      function toggleSound() {
        if (!v) return;
        if (v.muted) {
          document.querySelectorAll("[data-sl-ugc]").forEach(function (o) {
            if (o !== item) {
              o.classList.remove("is-playing");
              var ov = o.querySelector("video");
              if (ov) ov.muted = true;
            }
          });
          v.muted = false;
          var p = v.play(); if (p && p.catch) p.catch(function () {});
          item.classList.add("is-playing");
        } else { v.muted = true; item.classList.remove("is-playing"); }
      }
      item.addEventListener("click", toggleSound);
      item.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); toggleSound(); }
      });
    });
  }

  /* ---------- size guide modal ---------- */
  function initSizeGuide() {
    var modal = document.querySelector("[data-sl-sizeguide-modal]");
    if (!modal) return;
    var dialog = modal.querySelector(".sl-sg__dialog"), lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.documentElement.style.overflow = "hidden";
      var closeBtn = modal.querySelector(".sl-sg__close");
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      modal.hidden = true;
      document.documentElement.style.overflow = "";
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    document.querySelectorAll("[data-sl-sizeguide]").forEach(function (t) {
      t.addEventListener("click", function (e) { e.preventDefault(); open(); });
    });
    modal.querySelectorAll("[data-sl-sg-close]").forEach(function (c) { c.addEventListener("click", close); });
    modal.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { close(); return; }
      if (e.key === "Tab") {
        var f = Array.prototype.filter.call(
          dialog.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
          function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    var tables = modal.querySelectorAll("[data-sl-sg-table]");
    modal.querySelectorAll("[data-sl-sg-unit]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var unit = btn.getAttribute("data-sl-sg-unit");
        modal.querySelectorAll("[data-sl-sg-unit]").forEach(function (b) {
          var on = b.getAttribute("data-sl-sg-unit") === unit;
          b.classList.toggle("is-active", on);
          b.setAttribute("aria-pressed", on ? "true" : "false");
        });
        tables.forEach(function (t) { t.classList.toggle("is-cm", unit === "cm"); });
      });
    });
  }

  /* ---------- size calculator ---------- */
  function initSizeCalc() {
    var modal = document.querySelector("[data-sl-sizeguide-modal]");
    if (!modal) return;
    var calc = modal.querySelector("[data-sl-calc]");
    if (!calc) return;
    var CM_PER_IN = 2.54,
        VER = calc.getAttribute("data-sl-calc-ver") || "v1",
        PAGE = calc.getAttribute("data-sl-calc-page") || "",
        head = calc.querySelector("[data-sl-calc-toggle]"),
        panel = calc.querySelector(".sl-sg__calc-panel"),
        result = calc.querySelector("[data-sl-calc-result]");
    if (!head || !panel || !result) return;
    var idleHTML = result.innerHTML, inputs = {}, touched = { w: false, h: false }, rows = [];
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
    function parseCm(cell) {
      if (!cell) return null;
      var el = cell.querySelector(".u-cm");
      if (!el) return null;
      var parts = el.textContent.replace(/cm/gi, "").replace(/\s/g, "").split(/[–—-]/),
          a = parseFloat(parts[0]), b = parts.length > 1 ? parseFloat(parts[1]) : parseFloat(parts[0]);
      return isFinite(a) && isFinite(b) ? [a, b] : null;
    }
    function readRows() {
      var t = modal.querySelector("[data-sl-sg-table]");
      if (!t) return [];
      var heads = Array.prototype.map.call(t.querySelectorAll("thead th"), function (th) { return th.textContent.trim().toUpperCase(); }),
          wi = heads.indexOf("WAIST"), hi = heads.indexOf("HIPS");
      if (wi < 0 || hi < 0) return [];
      var out = [];
      Array.prototype.forEach.call(t.querySelectorAll("tbody tr"), function (tr) {
        var cells = Array.prototype.slice.call(tr.children), th = tr.querySelector("th"),
            w = parseCm(cells[wi]), h = parseCm(cells[hi]);
        if (th && w && h) out.push({ s: th.textContent.trim(), w: w, h: h });
      });
      return out;
    }
    function isCm() { var t = modal.querySelector("[data-sl-sg-table]"); return !!(t && t.classList.contains("is-cm")); }
    function fmt(cm) { return isCm() ? String(Math.round(cm)) : (cm / CM_PER_IN).toFixed(1); }
    function paintValues() {
      ["w", "h"].forEach(function (k) {
        var out = calc.querySelector('[data-sl-calc-out="' + k + '"]');
        if (out && inputs[k]) out.textContent = touched[k] ? fmt(+inputs[k].value) : "—";
      });
      Array.prototype.forEach.call(calc.querySelectorAll("[data-sl-calc-suffix]"), function (el) { el.textContent = isCm() ? "cm" : "in"; });
    }
    function idxFor(key, v) {
      for (var i = 0; i < rows.length; i++) if (v <= rows[i][key][1]) return i;
      return rows.length - 1;
    }
    function recommend(w, h) {
      var last = rows.length - 1, iW = idxFor("w", w), iH = idxFor("h", h), diff = iH - iW, i = iW, why;
      if (diff >= 2) { i = Math.min(iW + 1, last); why = "Your hips decide this one, so the waist sits a little gentler."; }
      else if (diff === 1) why = "Your waist decides this one — the brief stretches over the hip.";
      else if (diff === 0) why = "Your waist decides this one. Your hips confirm it.";
      else why = "Your waist decides this one, and your hips sit comfortably inside it.";
      if (i === last && w > rows[last].w[1]) why = "This is our largest size, and it is the one for you.";
      return { size: rows[i].s, why: why, conf: diff >= 2 ? "hip-led" : "waist-led" };
    }
    var CONFIRM = result.getAttribute("data-confirm") || "This is your size.",
        FIRM = result.getAttribute("data-firm") || "",
        EXCHANGE = result.getAttribute("data-exchange") || "";
    function render() {
      if (!rows.length || !touched.w || !touched.h) { result.innerHTML = idleHTML; return; }
      var r = recommend(+inputs.w.value, +inputs.h.value);
      result.setAttribute("data-size", r.size);
      result.setAttribute("data-conf", r.conf);
      result.innerHTML =
        '<div class="sl-sg__calc-card"><span class="sl-sg__calc-badge">' + esc(r.size) +
        '</span><span class="sl-sg__calc-conf">' + esc(CONFIRM) + '</span><p class="sl-sg__calc-why">' + r.why + "</p>" +
        (FIRM ? '<p class="sl-sg__calc-firm">' + esc(FIRM) + "</p>" : "") +
        '<button type="button" class="sl-sg__calc-cta" data-sl-calc-apply>Use size ' + esc(r.size) + "</button>" +
        (EXCHANGE ? '<span class="sl-sg__calc-exch">' + esc(EXCHANGE) + "</span>" : "") + "</div>";
    }
    function paintBadge(size) {
      var wrap = document.querySelector(".sl-sizeguide-wrap");
      if (wrap) wrap.classList.add("has-reco");
      Array.prototype.forEach.call(document.querySelectorAll("[data-sl-reco-pill]"), function (pill) {
        pill.hidden = false;
        var label = pill.querySelector("[data-sl-reco-label]");
        if (label) label.innerHTML = "Your size: <b>" + esc(size) + "</b>";
      });
    }
    function logReco(w, h, size, conf) {
      try {
        fetch("/cart/update.js", {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ attributes: { sz_waist: String(Math.round(w)), sz_hips: String(Math.round(h)), sz_unit: "cm", sz_reco: size, sz_conf: conf, sz_ver: VER, sz_page: PAGE } })
        }).catch(function () {});
      } catch (e) {}
    }
    var chart = modal.querySelector("[data-sl-chart]"),
        chartHead = modal.querySelector("[data-sl-chart-toggle]"),
        chartBody = modal.querySelector(".sl-sg__chart-body");
    function setChart(open) {
      if (!chart) return;
      if (open) chart.setAttribute("data-open", ""); else chart.removeAttribute("data-open");
      if (chartBody) chartBody.hidden = !open;
      if (chartHead) chartHead.setAttribute("aria-expanded", open ? "true" : "false");
    }
    function setCalc(open) {
      if (open) {
        rows = readRows();
        calc.setAttribute("data-open", ""); panel.hidden = false;
        head.setAttribute("aria-expanded", "true");
        paintValues(); render();
      } else {
        calc.removeAttribute("data-open"); panel.hidden = true;
        head.setAttribute("aria-expanded", "false");
      }
    }
    head.addEventListener("click", function () { setCalc(!calc.hasAttribute("data-open")); });
    if (chartHead) chartHead.addEventListener("click", function () { setChart(!chart.hasAttribute("data-open")); });
    Array.prototype.forEach.call(document.querySelectorAll("[data-sl-sizeguide]"), function (t) {
      var wantsCalc = t.hasAttribute("data-sl-reco-pill") || t.hasAttribute("data-sl-open-calc");
      t.addEventListener("click", function () {
        setTimeout(function () {
          setCalc(wantsCalc); setChart(true);
          var body = modal.querySelector(".sl-sg__body");
          if (body) body.scrollTop = 0;
        }, 0);
      });
    });
    ["w", "h"].forEach(function (k) {
      var el = calc.querySelector('[data-sl-calc-input="' + k + '"]');
      if (el) {
        inputs[k] = el;
        el.addEventListener("input", function () { touched[k] = true; paintValues(); render(); });
      }
    });
    Array.prototype.forEach.call(calc.querySelectorAll("[data-sl-calc-step]"), function (b) {
      b.addEventListener("click", function () {
        var p = b.getAttribute("data-sl-calc-step").split("|"), el = inputs[p[0]];
        if (el) {
          el.value = Math.max(+el.min, Math.min(+el.max, +el.value + +p[1]));
          touched[p[0]] = true; paintValues(); render();
        }
      });
    });
    Array.prototype.forEach.call(modal.querySelectorAll("[data-sl-sg-unit]"), function (b) {
      b.addEventListener("click", function () { setTimeout(paintValues, 0); });
    });
    result.addEventListener("click", function (e) {
      var btn = e.target && e.target.closest ? e.target.closest("[data-sl-calc-apply]") : null;
      if (!btn) return;
      var size = result.getAttribute("data-size");
      if (!size) return;
      logReco(+inputs.w.value, +inputs.h.value, size, result.getAttribute("data-conf") || "");
      try { sessionStorage.setItem("slReco", size); } catch (err) {}
      paintBadge(size);
      /* apply the size to every bundle unit row */
      document.querySelectorAll("[data-sl-unit-size]").forEach(function (sel) {
        if (Array.prototype.some.call(sel.options, function (o) { return o.value === size; })) sel.value = size;
      });
      document.dispatchEvent(new CustomEvent("contoura:size-applied", { detail: { size: size } }));
      var closer = modal.querySelector("[data-sl-sg-close]");
      if (closer) closer.click();
    });
    try {
      var prev = sessionStorage.getItem("slReco");
      if (prev) paintBadge(prev);
    } catch (e) {}
  }

  /* ---------- reviews carousel dots ---------- */
  function initReviews() {
    document.querySelectorAll("[data-sl-reviews]").forEach(function (sec) {
      var track = sec.querySelector("[data-sl-reviews-track]"),
          dotsWrap = sec.querySelector("[data-sl-reviews-dots]");
      if (!track || !dotsWrap) return;
      var cards = track.children, dots = [];
      for (var i = 0; i < cards.length; i++) {
        var b = document.createElement("button");
        b.className = "sl-rev__dot"; b.type = "button";
        b.setAttribute("aria-label", "Go to review " + (i + 1));
        (function (idx) {
          b.addEventListener("click", function () {
            cards[idx].scrollIntoView({ behavior: reduce ? "auto" : "smooth", inline: "center", block: "nearest" });
          });
        })(i);
        dotsWrap.appendChild(b); dots.push(b);
      }
      function active() {
        var center = track.scrollLeft + track.clientWidth / 2, best = 0, bestD = Infinity;
        for (var i2 = 0; i2 < cards.length; i2++) {
          var c = cards[i2], cc = c.offsetLeft + c.offsetWidth / 2, d = Math.abs(cc - center);
          if (d < bestD) { bestD = d; best = i2; }
        }
        dots.forEach(function (dot, i3) { dot.classList.toggle("is-active", i3 === best); });
      }
      track.addEventListener("scroll", function () { window.requestAnimationFrame(active); });
      active();
    });
  }

  /* ---------- engineered auto-walk ---------- */
  function initEngineered() {
    var grid = document.querySelector("[data-sl-eng-walk]");
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll(".sl-eng__crop"));
    if (cards.length < 2) return;
    var idx = 0, paused = false, timer = null, tapTimer = null;
    function set(i) {
      idx = ((i % cards.length) + cards.length) % cards.length;
      cards.forEach(function (c, j) { c.classList.toggle("is-active", j === idx); });
    }
    set(0);
    cards.forEach(function (card, i) {
      card.addEventListener("mouseenter", function () { paused = true; set(i); });
      card.addEventListener("mouseleave", function () { paused = false; });
      card.addEventListener("focusin", function () { paused = true; set(i); });
      card.addEventListener("focusout", function () { paused = false; });
      card.addEventListener("click", function () {
        set(i); paused = true;
        clearTimeout(tapTimer);
        tapTimer = setTimeout(function () { paused = false; }, 4000);
      });
    });
    if (reduce) return;
    function start() { if (!timer) timer = setInterval(function () { if (!paused) set(idx + 1); }, 3500); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.isIntersecting && e.intersectionRatio >= 0.5 ? start() : stop(); });
      }, { threshold: [0, 0.5, 1] }).observe(grid);
    } else start();
  }

  /* ---------- ships-by date ---------- */
  function initShipBy() {
    document.querySelectorAll("[data-sl-shipby]").forEach(function (el) {
      var days = parseInt(el.getAttribute("data-days"), 10);
      if (isNaN(days)) days = 1;
      if (days < 1) days = 1;
      var d = new Date();
      d.setDate(d.getDate() + days);
      el.textContent = " " + d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
    });
  }

  /* ---------- ship-to flag ---------- */
  function initShipFlag() {
    document.querySelectorAll("[data-sl-shipto]").forEach(function (box) {
      var slot = box.querySelector("[data-sl-shipto-ic]"), nameEl = box.querySelector("[data-sl-shipto-name]");
      if (!slot || !nameEl) return;
      function setFlag(code, name) {
        code = (code || "").trim().toLowerCase();
        if (!/^[a-z]{2}$/.test(code)) return;
        var img = new Image();
        img.onload = function () {
          img.className = "sl-shipto__flag"; img.alt = "";
          slot.innerHTML = ""; slot.appendChild(img);
          if (name) nameEl.textContent = "Shipping to " + name;
        };
        img.onerror = function () {};
        img.srcset = "https://flagcdn.com/h40/" + code + ".png 2x";
        img.src = "https://flagcdn.com/h20/" + code + ".png";
      }
      var iso = box.getAttribute("data-iso");
      if (iso) setFlag(iso);
      fetch("https://get.geojs.io/v1/ip/country.json")
        .then(function (r) { return r.json(); })
        .then(function (d) { if (d && d.country) setFlag(d.country, d.name); })
        .catch(function () {});
    });
  }

  /* ---------- rotating trust line ---------- */
  function initTrustRotate() {
    document.querySelectorAll("[data-sl-trust]").forEach(function (box) {
      var textEl = box.querySelector("[data-sl-trust-text]"),
          listEl = box.parentNode.querySelector("[data-sl-trust-list]");
      if (!textEl || !listEl) return;
      var msgs = [];
      try { msgs = JSON.parse(listEl.textContent).map(function (m) { return (m || "").trim(); }).filter(Boolean); } catch (e) {}
      if (reduce || msgs.length < 2) return;
      var i = 0, paused = false;
      box.addEventListener("mouseenter", function () { paused = true; });
      box.addEventListener("mouseleave", function () { paused = false; });
      setInterval(function () {
        if (paused) return;
        i = (i + 1) % msgs.length;
        textEl.style.opacity = "0";
        setTimeout(function () { textEl.textContent = msgs[i]; textEl.style.opacity = "1"; }, 300);
      }, 3750);
    });
  }

  /* ---------- scarcity countdown ---------- */
  function initTimer() {
    document.querySelectorAll("[data-sl-timer]").forEach(function (box) {
      var minEl = box.querySelector("[data-sl-min]"), secEl = box.querySelector("[data-sl-sec]");
      if (!minEl || !secEl) return;
      var startMin = parseInt(box.getAttribute("data-sl-timer-init"), 10);
      if (isNaN(startMin) || startMin < 1) startMin = 7;
      var total;
      try {
        var saved = sessionStorage.getItem("ctTimer");
        total = saved !== null ? parseInt(saved, 10) : startMin * 60;
      } catch (e) { total = startMin * 60; }
      if (isNaN(total) || total <= 0) total = startMin * 60;
      function paint() {
        var m = Math.floor(total / 60), s = total % 60;
        minEl.textContent = (m < 10 ? "0" : "") + m;
        secEl.textContent = (s < 10 ? "0" : "") + s;
      }
      paint();
      setInterval(function () {
        total = total > 0 ? total - 1 : startMin * 60;
        try { sessionStorage.setItem("ctTimer", String(total)); } catch (e) {}
        paint();
      }, 1000);
    });
  }

  /* ---------- bundle engine (native replacement for the swipe's bundle app) ---------- */
  function money(cents, format) {
    var s = (cents / 100).toFixed(2);
    return format ? format.replace("{{amount}}", s) : "$" + s;
  }
  function initBundle() {
    var root = document.querySelector("[data-sl-bundle]");
    if (!root) return;
    var variants = [], colors = [], moneyFormat = root.getAttribute("data-money-format") || "${{amount}}";
    try { variants = JSON.parse(root.querySelector("[data-sl-bundle-variants]").textContent); } catch (e) { return; }
    try { colors = JSON.parse(root.querySelector("[data-sl-bundle-colors]").textContent); } catch (e) {}
    var colorImg = {};
    colors.forEach(function (c) { if (c.image) colorImg[c.name] = c.image; });
    var cards = Array.prototype.slice.call(root.querySelectorAll("[data-sl-tier]"));
    var atcBtn = document.querySelector("[data-sl-atc]");
    var errEl = document.querySelector("[data-sl-atc-error]");

    function selectedCard() {
      for (var i = 0; i < cards.length; i++)
        if (cards[i].classList.contains("is-selected")) return cards[i];
      return cards[0];
    }
    function select(card) {
      cards.forEach(function (c) {
        var on = c === card;
        c.classList.toggle("is-selected", on);
        var radio = c.querySelector("[data-sl-tier-radio]");
        if (radio) radio.setAttribute("aria-checked", on ? "true" : "false");
        var units = c.querySelector("[data-sl-tier-units]");
        if (units) units.hidden = !on;
      });
      syncCta();
    }
    function rowsOf(card) { return Array.prototype.slice.call(card.querySelectorAll("[data-sl-unit-row]")); }
    function rowChoice(row) {
      var colorSel = row.querySelector("[data-sl-unit-color]"), sizeSel = row.querySelector("[data-sl-unit-size]");
      return { color: colorSel ? colorSel.value : "", size: sizeSel ? sizeSel.value : "" };
    }
    function findVariant(bundle, size, color) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.b === bundle && v.s === size && v.c === color) return v;
      }
      return null;
    }
    function syncThumb(row) {
      var img = row.querySelector("[data-sl-unit-thumb]");
      if (!img) return;
      var c = rowChoice(row).color;
      if (colorImg[c]) { img.src = colorImg[c]; img.alt = c; }
    }
    function syncCta() {
      var card = selectedCard();
      if (!card || !atcBtn) return;
      var priceEl = atcBtn.querySelector("[data-sl-atc-price]");
      if (priceEl) priceEl.textContent = money(parseInt(card.getAttribute("data-price"), 10), moneyFormat);
      var stickyPrice = document.querySelector("[data-sl-sticky-price]");
      if (stickyPrice) stickyPrice.textContent = money(parseInt(card.getAttribute("data-price"), 10), moneyFormat);
    }
    cards.forEach(function (card) {
      card.addEventListener("click", function (e) {
        if (e.target.closest("select")) return;
        select(card);
      });
      var radio = card.querySelector("[data-sl-tier-radio]");
      if (radio) radio.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); select(card); }
      });
      rowsOf(card).forEach(function (row) {
        var colorSel = row.querySelector("[data-sl-unit-color]");
        if (colorSel) colorSel.addEventListener("change", function () { syncThumb(row); });
        syncThumb(row);
      });
    });
    document.addEventListener("contoura:size-applied", function () { /* selects already set */ });

    if (atcBtn) atcBtn.addEventListener("click", function () {
      var card = selectedCard();
      if (!card) return;
      var bundle = card.getAttribute("data-bundle");
      var rows = rowsOf(card);
      if (!rows.length) return;
      var first = rowChoice(rows[0]);
      var v = findVariant(bundle, first.size, first.color);
      if (!v) {
        if (errEl) { errEl.textContent = "This combination is unavailable — try another color or size."; errEl.hidden = false; }
        return;
      }
      if (errEl) errEl.hidden = true;
      var props = {};
      for (var i = 1; i < rows.length; i++) {
        var ch = rowChoice(rows[i]);
        props["Brief #" + (i + 1)] = ch.color + " / " + ch.size;
      }
      props["Brief #1"] = first.color + " / " + first.size;
      atcBtn.disabled = true;
      var label = atcBtn.querySelector("[data-sl-atc-label]");
      var old = label ? label.textContent : "";
      if (label) label.textContent = "Adding…";
      var drawer = document.querySelector("cart-drawer");
      var payload = { items: [{ id: v.id, quantity: 1, properties: props }] };
      if (drawer && drawer.dataset.sectionId) payload.sections = drawer.dataset.sectionId;
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (!r.ok) throw new Error("add failed");
        return r.json();
      }).then(function (data) {
        if (!drawer) { window.location.href = root.getAttribute("data-cart-url") || "/cart"; return; }
        return fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
          document.dispatchEvent(new CustomEvent("cart:updated", { detail: { data: { sections: data.sections || {}, itemCount: cart.item_count } } }));
          document.dispatchEvent(new CustomEvent("cart:open"));
          atcBtn.disabled = false;
          if (label) label.textContent = old;
        });
      }).catch(function () {
        atcBtn.disabled = false;
        if (label) label.textContent = old;
        if (errEl) { errEl.textContent = "Something went wrong — please try again."; errEl.hidden = false; }
      });
    });
    /* initial state */
    var preselected = root.querySelector("[data-sl-tier].is-selected") || cards[0];
    if (preselected) select(preselected);
  }

  /* ---------- eager gallery warmup ---------- */
  function warmGallery() {
    var slides = document.querySelectorAll("[data-sl-gallery] .sl-gallery__slide");
    if (!slides.length) return;
    var run = function () {
      slides.forEach(function (s) {
        if (s.getAttribute("loading") === "lazy") { s.setAttribute("fetchpriority", "low"); s.loading = "eager"; }
      });
    };
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 700); };
    if (document.readyState === "complete") idle(run);
    else window.addEventListener("load", function () { idle(run); });
  }

  function init() {
    initReveal(); initFaq(); initGallery(); initThumbArrows(); initSticky();
    initCarousels(); initUgc(); initSizeGuide(); initSizeCalc(); initReviews();
    initEngineered(); initShipBy(); initShipFlag(); initTrustRotate(); initTimer();
    initBundle(); warmGallery();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
